import {
  IListOrderFetchParams,
  IOrder,
  MN_ORDERS,
  useList,
} from '@jobcost-monorepo/crud';
import { createRepository } from '@jobcost-monorepo/crud/dto/repositoryFactory';
import React, { useEffect, useRef, useState } from 'react';
import { ScheduledOrder } from './types';
import { manipulateOrders } from './helperOrdersScheduled';
import OrderScheduledHeader from './Header';
import OrdersScheduledBody from './Body';
import { Loader } from '@jobcost-monorepo/ui';

export default function OrdersScheduledPage() {
  const ref = useRef<HTMLDivElement>(null);
  const repository = createRepository<IOrder, IListOrderFetchParams>(MN_ORDERS);
  const [start, setStart] = useState<string>('');
  const [end, setEnd] = useState<string>('');
  const [groupedData, setGroupedData] = useState<ScheduledOrder[]>([]);

  const { fetchDataList, dataList, params, loading } = useList<
    IOrder,
    IListOrderFetchParams
  >({
    moduleName: MN_ORDERS,
    repository: repository,
    updateStore: false,
  });

  const handleSearch = async (
    startDate: string,
    endDate: string,
    resourceId?: number,
  ) => {
    setStart(startDate);
    setEnd(endDate);
    await fetchDataList({
      startDate,
      endDate,
      resourceId,
      excludeRevenue: false,
      orderState: 'Running',
      jobState: 'Running',
    });
  };

  const handleData = () => {
    const data = manipulateOrders(dataList.data, start, end);
    setGroupedData(data);
  };

  useEffect(() => {
    handleData();
  }, [loading]);

  return (
    <div className="flex flex-col size-full">
      <div className="mx-6 pt-6">
        <OrderScheduledHeader params={params} handleSearch={handleSearch} />
      </div>
      <Loader showLoader={loading} />
      <div className="px-6 pt-6 overflow-y-auto">
        <OrdersScheduledBody ref={ref} dataList={groupedData} />
      </div>
    </div>
  );
}
